export enum LinkTypes {
  Call,
  Navigation,
  Contact,
}